import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manhwa';

type BreadcrumbItem = {
  label: string;
  href?: string;
};

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.href ? `https://bluefocugroup.cn${item.href}` : undefined,
        name: item.label,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="max-w-7xl mx-auto px-4 md:px-6 pt-24 pb-4">
        <ol className="flex items-center gap-1 text-sm text-foreground-500 flex-wrap">
          <li>
            <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
          </li>
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            const catName = categories.find(c => item.href?.includes(c.slug))?.name;
            return (
              <li key={index} className="flex items-center gap-1">
                <span className="text-foreground-400">/</span>
                {isLast || !item.href ? (
                  <span className="text-foreground-800 font-medium whitespace-nowrap">{item.label}</span>
                ) : (
                  <Link
                    to={item.href}
                    className="hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {catName || item.label}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}